var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.inMyTickList)?_c('v-btn',{attrs:{"text":"","outlined":"","color":"primary","loading":_vm.loadingAdd},on:{"click":function($event){return _vm.addInTickList()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n    "+_vm._s(_vm.mdiCropFree)+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.$t('actions.addInMyTickList'))+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }